<template>
    <v-dialog
        v-model="$store.state.fuel.check"
        max-width="800px"
    >
    <v-card>
        <v-toolbar dark color="secondary" dense>
            <v-spacer />
            <v-toolbar-title class="white--text"
                >Check Excel Statement : {{ statement }}</v-toolbar-title
            >
            <v-spacer></v-spacer>
                <v-btn
                    dark
                    icon
                    left
                    @click="$store.state.fuel.check = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
        </v-toolbar>
        <v-container grid-list-xs fluid>
          <v-simple-table dense>
             <thead>
                <tr>
                    <th>Product Code</th>
                    <th>Product</th>
                    <th>Total Records</th>
                    <th>Total ActualCost</th>
                </tr>
             </thead>
             <tbody>
                <tr v-for="(itm,i) in excel" v-bind:key="i">
                    <td>{{ itm.ProductCode }}</td>
                    <td>{{ itm.Product }}</td>
                    <td>{{ itm.Total }}</td>
                    <td>{{ itm.ActualCost }}</td>
                </tr>
                <tr>
                    <th colspan="2"> Totals</th>
                    <td>{{ records[0].Total }}</td>
                    <td>{{ records[0].ActualCost }}</td>
                </tr>
             </tbody>
          </v-simple-table>
        </v-container>
    </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    props:['statement'],
    data: function() {
        return {
            excel: null,
            records:[
                {Total: 0,ActualCost:0}
            ],
        };
    },
    mounted() {
        this.checkTotals();
    },
    methods: {
        checkTotals: function() {
            var str = this.$store;
             str.state.isLoading = true;
             axios
                 .get('fuel-expense/totals/excel/'+ this.statement, {
                     headers: {
                         Authorization: 'Bearer ' + this.$store.state.token
                     }
                 })
                 .then(response => {
                     console.log(response.data);
                     this.excel = response.data['total'];
                     this.records = response.data['records'];
                     str.state.isLoading = false;
                 })
                 .catch(function(error) {
                     console.log(error);
                     if (error.response.status === 403) {
                         str.dispatch('setSnackbar', {
                             color: 'error',
                             text:
                                 'You do not have the permission to use this function.'
                         });
                     }
                       str.state.isLoading = false;
                 });
        }
    }
};
</script>
